// eslint-disable-next-line import/no-anonymous-default-export
export default `
type Query {
    userGroups: [String]
}
`